import { confirmTaxIdFieldConfig, taxIdFieldConfig } from "./_common";
import { FieldTypes } from "pages/employer-of-record/components/AutoForm";
import { array, countryIs, field, REQUIRED } from "./utils";
import {
  DEGREE_OPTIONS,
  TITLE_OPTIONS,
  MARITAL_STATUS_OPTIONS,
  RESIDENT_CARD_TYPE_OPTIONS,
} from "pages/employer-of-record/onboarding/profile-info/form/fr/constants.fr";
import { NATIONALITIES } from "pages/employer-of-record/onboarding/profile-info/constants";

const residentCardNumber = field({
  type: FieldTypes.text,
  name: "residentCardNumber",
  label: "N° Titre de séjour (Resident Card Number)",
  validations: {
    ...REQUIRED,
    text: {
      max: { value: 20, message: "Must be a valid Resident Card Number" },
    },
  },
  scenarios: {
    onboarding: countryIs("FR"),
  },
  value: () => "", //TODO: Expose residentCardNumber
});

const residentCardEndDate = field({
  type: FieldTypes.date,
  name: "residentCardEndDate",
  label: "Date de fin de validité Titre de séjour (Resident Card End Date)",
  validations: {
    ...REQUIRED,
    date: {
      min: { value: new Date(), message: "Must be a valid date" },
    },
  },
  scenarios: {
    onboarding: countryIs("FR"),
  },
  value: () => "", //TODO: Expose residentCardEndDate
});

const residentCardStartDate = field({
  type: FieldTypes.date,
  name: "residentCardStartDate",
  label: "Date début de validité Titre de séjour (Resident Card Start Date)",
  validations: {
    ...REQUIRED,
    date: {
      max: { value: new Date(), message: "Must be a valid date" },
    },
  },
  scenarios: {
    onboarding: countryIs("FR"),
  },
  value: () => "", //TODO: Expose residentCardStartDate
});

const residentCardType = field({
  type: FieldTypes.select,
  name: "residentCardType",
  label: "Type de Titre de séjour (Resident Card Type)",
  placeholder: "Select Resident Card Type",
  validations: REQUIRED,
  options: RESIDENT_CARD_TYPE_OPTIONS,
  scenarios: {
    onboarding: countryIs("FR"),
  },
  value: () => "", //TODO: Expose residentCardType
});

export const franceFields = {
  frTitle: field({
    type: FieldTypes.select,
    informationType: "identification",
    name: "frTitle",
    label: "Civilité du salarié (Title)",
    placeholder: "Select Title",
    options: TITLE_OPTIONS,
    validations: REQUIRED,
    scenarios: {
      onboarding: countryIs("FR"),
    },
    value: () => "", // TODO: Expose frTitle
  }),
  frMaidenName: field({
    type: FieldTypes.text,
    informationType: "identification",
    name: "frMaidenName",
    label: "Nom de jeune fille (Maiden name)",
    scenarios: {
      onboarding: countryIs("FR"),
    },
    value: () => "", // TODO: Expose frMaidenName
  }),
  frBirthCountry: field({
    type: FieldTypes.select,
    name: "frBirthCountry",
    label: "Pays de naissance (Country of Birth)",
    validations: REQUIRED,
    placeholder: "Select Country",
    options: NATIONALITIES,
    scenarios: {
      onboarding: countryIs("FR"),
    },
    informationType: "identification",
    value: () => "", //TODO: Expose frBirthCountry
  }),
  frBirthProvince: field({
    type: FieldTypes.select,
    name: "frBirthProvince",
    label: "Département de naissance (Province of Birth)",
    placeholder: "Select Province of Birth",
    options: [],
    scenarios: {
      onboarding: countryIs("FR"),
    },
    informationType: "identification",
    hideWhen: {
      frBirthCountry: (value) => typeof value === "string" && value !== "FR",
    },
    value: () => "", //TODO: Expose frBirthProvince
  }),

  frBirthPlace: field({
    type: FieldTypes.text,
    name: "frBirthPlace",
    label: "Lieu de naissance (Place of Birth)",
    validations: REQUIRED,
    scenarios: {
      onboarding: countryIs("FR"),
    },
    informationType: "identification",
    value: () => "", //TODO: Expose frBirthPlace
  }),
  frEDoc: field({
    type: FieldTypes.boolean,
    name: "frEDoc",
    label: "Secure Digital Payslip",
    validations: REQUIRED,
    scenarios: {
      onboarding: countryIs("FR"),
    },
    informationType: "identification",
    value: () => false, //TODO: Expose frEDoc
  }),
  frHighestDegree: field({
    type: FieldTypes.select,
    name: "frHighestDegree",
    label: "Diplôme (Highest Degree of qualification)",
    validations: REQUIRED,
    placeholder: "Select Highest Degree",
    options: DEGREE_OPTIONS,
    scenarios: {
      onboarding: countryIs("FR"),
    },
    informationType: "education",
    value: () => "", //TODO: Expose frHighestDegree
  }),
  frMaritalStatus: field({
    type: FieldTypes.select,
    informationType: "identification",
    name: "frMaritalStatus",
    label: "Marital status",
    placeholder: "Select Marital status",
    validations: REQUIRED,
    options: MARITAL_STATUS_OPTIONS,
    scenarios: {
      onboarding: countryIs("FR"),
    },
    value: () => "", //TODO: Expose frMaritalStatus
  }),
  frDependentInformation: array({
    type: FieldTypes.object,
    array: {
      limit: 10,
      deletionStrategy: "any",
      itemLabelSuffix: "Dependent",
      showFirstItem: false,
    },
    name: "frDependentInformation",
    label: "Personnes à charge (Dependents)",
    validations: REQUIRED,
    placeholder: "Select Number of Dependents",
    scenarios: {
      onboarding: countryIs("FR"),
    },
    fields: [
      residentCardType,
      residentCardNumber,
      residentCardStartDate,
      residentCardEndDate,
    ],
    informationType: "family",
    serialize: (value) => {
      return value;
    },
    value: (_) => [], //TODO: Expose frNumDependents
  }),
  frSsn: taxIdFieldConfig("FR", "frSsn"),
  frConfirmSsn: confirmTaxIdFieldConfig("FR", "frSsn"),
};
